<template>
  <svg viewBox="5 5 40 40">
    <g style="display: inline">
      <g>
        <path
          d="M25.1,36.59c-0.06,0-0.13,0-0.19,0c-1-0.03-2.52-0.24-4.08-1.04l0,0c-7.22-3.71-4.87-8.64-3.32-11.9
			c0.52-1.09,1.01-2.12,0.94-2.73c-0.03-0.24,0.12-0.47,0.35-0.54c0.23-0.07,0.48,0.03,0.59,0.25c0.37,0.72,0.66,1.68,0.8,2.49
			c1.3-1.52,2.89-5.08,2.56-9.12c-0.01-0.18,0.07-0.35,0.22-0.45c0.15-0.1,0.34-0.11,0.5-0.03c0.99,0.49,4.56,2.97,5.85,6.53
			c0.02-0.42-0.04-0.78-0.18-1.09c-0.1-0.22-0.03-0.47,0.16-0.61c0.19-0.14,0.45-0.13,0.63,0.03c4.1,3.7,4.68,7.14,4.44,9.38
			c-0.32,3.05-2.32,5.83-5.47,7.65C27.49,36.22,26.31,36.59,25.1,36.59z M19.06,22.65c-0.18,0.45-0.41,0.93-0.65,1.44
			c-1.55,3.26-3.48,7.32,2.88,10.58l0,0c1.4,0.72,2.76,0.9,3.65,0.93c1.07,0.05,2.15-0.29,3.47-1.05c2.87-1.65,4.68-4.16,4.97-6.89
			c0.27-2.51-0.79-5.08-3.06-7.5c-0.05,0.81-0.32,1.61-0.57,2.23c-0.09,0.22-0.31,0.34-0.54,0.31c-0.23-0.04-0.41-0.23-0.42-0.46
			c-0.24-3.51-3.35-6.23-4.99-7.35c0.07,4.65-2.07,8.62-3.72,9.69c-0.15,0.1-0.35,0.11-0.51,0.02c-0.16-0.09-0.26-0.26-0.26-0.44
			C19.3,23.8,19.21,23.23,19.06,22.65z"
        />
      </g>
    </g>
    <g style="display: inline">
      <g>
        <path
          d="M11.81,13.09l0.59,4.47l-0.74,0.1l-0.4-3c-1.98,2.84-3.03,6.15-3.03,9.64c0,5.67,2.82,10.94,7.55,14.09l-0.55,0.83
			c-5.01-3.34-8-8.92-8-14.92c0-3.67,1.1-7.15,3.16-10.14l-2.84,0.59L7.4,14L11.81,13.09 M12.66,11.89l-1.05,0.22L7.2,13.02
			l-0.98,0.2l0.2,0.98l0.15,0.74l0.2,0.98l0.98-0.2l0.6-0.12c-1.4,2.68-2.13,5.65-2.13,8.7c0,6.34,3.16,12.23,8.44,15.76l0.83,0.55
			l0.55-0.83l0.55-0.83l0.55-0.83l-0.83-0.55c-4.45-2.96-7.11-7.92-7.11-13.26c0-2.29,0.49-4.52,1.43-6.57l0.01,0.07l0.13,0.99
			l0.99-0.13l0.74-0.1l0.99-0.13l-0.13-0.99l-0.59-4.47L12.66,11.89L12.66,11.89z"
        />
      </g>
      <g>
        <path
          d="M43.06,24.29c0,4.79-1.86,9.29-5.25,12.67c-3.38,3.38-7.88,5.25-12.67,5.25c-1.82,0-3.61-0.29-5.33-0.82l1.41,2.53
			l-0.66,0.37l-2.19-3.93l4.08-1.9l0.32,0.68l-2.75,1.28c1.65,0.53,3.37,0.81,5.13,0.81c4.52,0,8.77-1.76,11.96-4.95
			c3.19-3.2,4.95-7.44,4.95-11.96H43.06 M44.06,23.29h-1h-1h-1v1c0,4.25-1.66,8.25-4.66,11.26c-3.01,3.01-7,4.66-11.26,4.66
			c-0.68,0-1.37-0.05-2.05-0.14l0.1-0.05l0.91-0.42l-0.42-0.91l-0.32-0.68l-0.42-0.91l-0.91,0.42l-4.08,1.9l-0.97,0.45l0.52,0.94
			l2.19,3.93l0.49,0.87l0.87-0.49l0.66-0.37l0.87-0.49l-0.49-0.87l-0.29-0.52c1.11,0.2,2.23,0.3,3.34,0.3
			c5.05,0,9.8-1.97,13.38-5.54c3.57-3.57,5.54-8.32,5.54-13.38V23.29L44.06,23.29z"
        />
      </g>
      <g>
        <path
          d="M25.15,6.37c4.79,0,9.29,1.86,12.67,5.25c2.03,2.03,3.53,4.51,4.4,7.22l1.27-2.59l0.67,0.33l-1.98,4.05l-3.89-2.26
			l0.38-0.65l2.63,1.53c-0.81-2.6-2.24-4.98-4.18-6.92c-3.2-3.19-7.44-4.95-11.96-4.95c-3.91,0-7.73,1.37-10.75,3.85l-0.64-0.77
			C16.96,7.82,21,6.37,25.15,6.37 M25.15,5.37c-4.38,0-8.65,1.53-12.02,4.31l-0.77,0.64l0.64,0.77l0.64,0.77l0.64,0.77l0.77-0.64
			c2.84-2.34,6.43-3.62,10.11-3.62c4.25,0,8.25,1.66,11.26,4.66c1.13,1.13,2.09,2.44,2.83,3.86l-0.07-0.04l-0.87-0.5l-0.5,0.87
			l-0.38,0.65l-0.5,0.86l0.86,0.5l3.89,2.26l0.93,0.54l0.47-0.97l1.98-4.05l0.44-0.9l-0.9-0.44l-0.67-0.33l-0.9-0.44l-0.44,0.9
			l-0.26,0.54c-0.93-2.02-2.22-3.87-3.79-5.44C34.95,7.34,30.2,5.37,25.15,5.37L25.15,5.37z"
        />
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconGroeneWarmte extends Vue {}
</script>
